import { Graphics, Text } from "pixi.js";
import Layout from "../../../vendor_core/core/src/utils/Layout";
import BaseView from "../../../vendor_core/core/src/views/BaseView";

class TestSubview extends Graphics {

    private static count = 0;
    public defaultLayer = "reels";
    private number;

    constructor() {
        super();
        this.beginFill(0xFFFF00);
        this.lineStyle(2, 0xFF0000);
        this.drawRect(0, 0, 200, 200);
        // this.width = this.height = 100;

        this.tag();
        // this.scale.x= Layout.globalScale;
        // this.x =  200;
        // this.y = 200;
        // this.position = {x: Math.floor(Math.random() * 500),
        //     y: Math.floor(Math.random() * 500)} as Point;
    }

    private tag() {
        this.number = new Text(TestSubview.count.toString());
        this.addChild(this.number);
        TestSubview.count += 1;
    }

}

export default TestSubview;
